module.exports = __webpack_public_path__ + "img/SteelProducts.d4fce576.png";